import React from 'react';
import Button from '@mui/material/Button'
function DeleteProject() {
  return <div>
      <Button>Delete Projct</Button>
  </div>;
}

export default DeleteProject;
